import { getDeep } from './getDeep.js';

const interpolateFunction = ({ str = '', functionMatch, context = {} }) => {
  const fnPath = functionMatch[1].trim();
  const argsExpression = functionMatch[2];

  const fn = getDeep(fnPath, context);
  if (typeof fn !== 'function') {
    return str;
  }

  const args = [];
  let currentArg = '';
  let depth = 0;

  for (let i = 0; i < argsExpression.length; i++) {
    const char = argsExpression[i];

    if (char === '(' || char === '[' || char === '{') {
      depth++;
      currentArg += char;
    } else if (char === ')' || char === ']' || char === '}') {
      depth--;
      currentArg += char;
    } else if (char === ',' && depth === 0) {
      args.push(currentArg.trim());
      currentArg = '';
    } else {
      currentArg += char;
    }
  }

  if (currentArg.trim()) {
    args.push(currentArg.trim());
  }

  const processedArgs = args.map((arg) => {
    if (/^["'].*["']$/.test(arg)) {
      return arg.slice(1, -1);
    }

    const resolved = getDeep(arg, context);
    return resolved !== undefined ? resolved : arg;
  });

  try {
    return fn(...processedArgs);
  } catch (error) {
    console.error(`Error executing function ${fnPath}:`, error);
    return str;
  }
};

export default interpolateFunction;
